/* eslint-disable react/display-name */
import React, { ReactNodeArray } from 'react';
import { useIntl } from 'react-intl';
import * as hsEmbedded from 'common/utils/messages';
import messages from './intl';

import SadCat from '../images/sad-cat.png';

import styles from '../index.scss';

export type ErrorPageProps = {
  type: string,
  message: string | ReactNodeArray,
  instructions: string | ReactNodeArray,
  encodeInstructions?: boolean,
}

export enum ErrorTypes {
  Blocked = 'blocked',
  Unverified = 'unverified',
  Expired = 'expired',
  Mismatch = 'mismatch',
  Wrong = 'wrong',
  SaveBack = 'save-back',
  PullError = 'file-error',
  Unknown = 'unknown',
}

const sendCancelMessage = (_event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
  hsEmbedded.postMessage({ type: hsEmbedded.messages.USER_CANCEL_REQUEST }, 'https://www.dropbox.com');
};

const ErrorPage = (props: ErrorPageProps) => {
  const intl = useIntl();
  const instructions = props.encodeInstructions
    ? atob(props.instructions.toString())
    : props.instructions;
  const instructionsSendCancelToParent = props.type !== ErrorTypes.Blocked
    && props.type !== ErrorTypes.Unverified
    && props.type !== ErrorTypes.PullError;

  const getInstructions = (withCancelLink: boolean) => {
    if (withCancelLink) {
      return <a
        data-qa-ref="deep-integration-error-instructions-link"
        onClick={sendCancelMessage}
        className={styles.instructionsLink}
      >
        {instructions}
      </a>;
    }
    return props.encodeInstructions
      ? <div data-qa-ref="deep-integration-error-instructions"
          className={styles.instructions}
          dangerouslySetInnerHTML={{ __html: instructions.toString() }} />
      : <div data-qa-ref="deep-integration-error-instructions"
          className={styles.instructions}
      >{props.instructions}</div>;
  };

  return (
    <div className={styles.errorPage} data-qa-ref="deep-integration-error">
      <div className={styles.image} data-qa-ref="deep-integration-error-image">
        <img
          className={styles.sadCatImage}
          src={SadCat}
          alt={intl.formatMessage(messages.sadCat)} />
      </div>
      <div className={styles.description} data-qa-ref="deep-integration-error-description">
        {props.message}
      </div>
      {getInstructions(instructionsSendCancelToParent)}
    </div>
  );
};

export default ErrorPage;
